<template>
  <div class="section-spacing-20">
    <WarningMessage v-if="isDefault">
      <span>The generic component type cannot be edited.</span>
    </WarningMessage>
    <text-field
      v-model="formData.name"
      name="*Component Name"
      :validation-errors="v$.$errors"
      :error-message="firstErrorMessage(v$.formData?.name)"
      labelClass="mb-3 full-width"
      :disabled="isDefault"
    ></text-field>
    <text-area
      v-model="formData.description"
      name="Description"
      :disabled="isDefault"
    ></text-area>
  </div>
</template>

<script>
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import TextArea from "@/components/TextArea.vue";
import TextField from "@/components/TextField.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  components: {
    WarningMessage,
    TextField,
    TextArea
  },
  props: {
    componentType: {
      type: Object,
      default: null
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      formData: {
        name: "",
        description: ""
      }
    };
  },
  computed: {
    isDefault() {
      if (this.componentType && this.componentType.is_default) {
        return true;
      }

      return false;
    }
  },
  created() {
    this.setFormData();
  },
  validations() {
    return {
      formData: {
        name: { required, $autoDirty: true }
      }
    };
  },
  methods: {
    firstErrorMessage,
    async getData() {
      const isValid = await this.v$.$validate();
      if (isValid) {
        return this.formData;
      }
      // return null if there are form errors
      return null;
    },
    setFormData() {
      if (this.componentType) {
        const { name, description } = this.componentType;
        this.formData.name = name;
        this.formData.description = description;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
